import {Component, OnInit} from '@angular/core';
import {LocalStorageService} from '../../services/local-storage.service';
import {UserService} from '../../services/user/user.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-board-admin',
  styleUrls: ['./board-admin.component.scss'],
  templateUrl: './board-admin.component.html',
})
export class BoardAdminComponent implements OnInit {

  public currentUser: any;
  public showAdminBoard: boolean;
  public isSuperAdmin: boolean;
  public isAdmin: boolean;
  public isLoggedIn = false;
  private roles: string[];

  constructor(private localStorageService: LocalStorageService) { }

  public ngOnInit(): void {
    this.currentUser = this.localStorageService.getUser();
    this.isLoggedIn = !!this.localStorageService.getToken();

    if (this.isLoggedIn) {
      this.roles = this.currentUser.roles;
      this.showAdminBoard = this.roles.includes('ROLE_ADMIN');
      this.isSuperAdmin = this.roles.includes('ROLE_SUPER_ADMIN');
      this.isAdmin = this.roles.includes('ROLE_ADMIN');
    } else {
      window.location.href = `${environment.frontendUrl}/#/home/login`;
    }
  }
}
